export class Partialproductquote {
    constructor(
   public pensionFund: string = null,
   public commencementDate: string = null,
   public quoteDateFlag: boolean = false,
   public selectedProduct: string = null,
   public quoteRefNo: string = null,
   public selectedProductCode: string = null,
   public fundingSource: string = null) {
    }
}
